import { render, staticRenderFns } from "./title.vue?vue&type=template&id=6b5bafd4&fddApi"
import script from "./title.vue?vue&type=script&lang=js&fddApi"
export * from "./title.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports